import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DbContextService } from '../../../services/db-context.service';
import { Helper } from '../../common/helper';
import swal from 'sweetalert2';


@Injectable({
  providedIn: 'root'
})
export class AuditCorrectiveActionService {

  constructor(private http: HttpClient, private dbxService: DbContextService) { }

  getShipAuditHeader(auditHeaderID: any) {
    return this.http.get(Helper.API_URL() + `/api/VisitsAudits/GetShipAuditHeader/${auditHeaderID}`);
  }

  getShipAuditDetails(auditHeaderID: any) {
    return this.http.get(Helper.API_URL() + `/api/VisitsAudits/GetShipAuditDetailList/${auditHeaderID}`);
  }

  getAuditDepartmentList() {
    return this.http.get(Helper.API_URL() + `/api/Maintenance/GetAuditDepartmentList`);
  }

  submitCorrectiveActions(data: any) {
    return this.http.post(Helper.API_URL() + '/api/VisitsAudits/SubmitCorrectiveActions', data);
  }

  saveCorrectiveActions(data: any) {
    return this.http.post(Helper.API_URL() + '/api/VisitsAudits/SaveCorrectiveActions', data);
  }

  getAuditDepartmentListIndexDB(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblShipAuditDepartment', 'readwrite');
        tx.oncomplete = (ev) => {
        }
        tx.onerror = (err: any) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_tblShipAuditDepartment');
        store.getAll().then(
          (res: any) => {
            let list: any = [];
            res.forEach((row: any) => {
              list.push(Helper.deepCopy(row));
            });
            resolve(list);
          }
        )
      });
    });

    return promise;
  }

  getShipAuditHeaderIndexDB(auditHeaderID: number): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblShipAuditHeader', 'readwrite');
        tx.oncomplete = (ev) => {
        }
        tx.onerror = (err: any) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_tblShipAuditHeader');
        store.get(auditHeaderID).then(
          (res: any) => {
            resolve(res);
          }
        )
      });
    });

    return promise;
  }

  getShipAuditDetailsIndexDB(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblShipAuditDetails', 'readwrite');
        tx.oncomplete = (ev) => {
        }
        tx.onerror = (err: any) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_tblShipAuditDetails');
        store.getAll().then(
          (res: any) => {
            let list: any = [];
            res.forEach((row: any) => {
              list.push(Helper.deepCopy(row));
            });
            resolve(list);
          }
        )
      });
    });

    return promise;
  }

  saveAuditDepartmentListIndexDB(departmentList: any) {
    this.dbxService.openDatabase().then(db => {
      const tx = db.transaction('OWS_tblShipAuditDepartment', 'readwrite');
      tx.oncomplete = (ev) => {

      }
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      let store = tx.objectStore('OWS_tblShipAuditDepartment');
      store.clear();
      departmentList.forEach((row: any) => {
        try {
          let req = store.add(row);
        } catch (e: any) {
          if (e?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        }
      });
    });
  }

  saveShipAuditHeaderIndexDB(shipAuditHeader: any) {
    this.dbxService.openDatabase().then(db => {
      const tx = db.transaction('OWS_tblShipAuditHeader', 'readwrite');
      tx.oncomplete = (ev) => {

      }
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      let store = tx.objectStore('OWS_tblShipAuditHeader');
      store.get(shipAuditHeader.shipAuditHeaderID).then(
        (res: any) => {
          if (!res) {
            try {
              let req = store.add(shipAuditHeader);
            } catch (e: any) {
              if (e?.name === 'QuotaExceededError') {
                this.handleQuotaExceeded();
              }
            }
          }
        }
      )
    });
  }

  saveShipAuditDetailsIndexDB(auditDetails: any) {
    this.dbxService.openDatabase().then(db => {
      const tx = db.transaction('OWS_tblShipAuditDetails', 'readwrite');
      tx.oncomplete = (ev) => {

      }
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      let store = tx.objectStore('OWS_tblShipAuditDetails');
      auditDetails.forEach((row: any) => {
        store.get(row.shipAuditDetailID).then(
          (res: any) => {
            if (!res) {
              try {
                let req = store.add(row);
              } catch (e: any) {
                if (e?.name === 'QuotaExceededError') {
                  this.handleQuotaExceeded();
                }
              }
            }
          }
        )
      });
    });
  }

  updateOverviewIndexDB(auditHeaderID: number, isOffline: boolean): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblShipAuditOverview', 'readwrite');
        tx.oncomplete = (ev) => {

        }

        tx.onabort = (event: any) => {
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        tx.onerror = (event: any) => {
          console.warn(event);
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        let store = tx.objectStore('OWS_tblShipAuditOverview');
        store.get(auditHeaderID).then(
          (res: any) => {
            if (res) {
              res.isOffline = isOffline;
              try {
                let req = store.put(res).then(
                  (res2: any) => {
                    resolve(res2);
                  }
                );
              } catch (e: any) {
                if (e?.name === 'QuotaExceededError') {
                  this.handleQuotaExceeded();
                }
              }
            }
          }
        )

        tx.done;// complete;
      });
    })

    return promise;

  }

  // #region ** Corrective Action Photos: -------------------------- **
  getShipAuditCorrectiveActionPhotoList(shipAuditCorrectiveActionPhotoIDList: any, shipAuditDetailIDList: any, docFileNameList: any) {
    const paramObject = {
      'shipAuditCorrectiveActionPhotoIDList': shipAuditCorrectiveActionPhotoIDList,
      'shipAuditDetailIDList': shipAuditDetailIDList,
      'docFileNameList': docFileNameList
    }
    return this.http.post(Helper.API_URL() + '/api/VisitsAudits/GetShipAuditCorrectiveActionPhotoList', paramObject);
  }

  createShipAuditCorrectiveActionPhoto(data: any) {
    return this.http.post(Helper.API_URL() + '/api/VisitsAudits/CreateShipAuditCorrectiveActionPhoto', data);
  }

  getCorrectiveActionPhotoDirectoryPath() {
    return this.http.get(Helper.API_URL() + '/api/VisitsAudits/GetShipAuditFileDirectoryPath');
  }

  uploadCorrectiveActionPhoto(file: any) {
    return this.http.post(Helper.API_URL() + '/api/VisitsAudits/UploadShipAuditCorrectiveActionPhoto', file);
  }

  deleteShipAuditCorrectiveActionPhoto(data: any) {
    return this.http.post(Helper.API_URL() + '/api/VisitsAudits/DeleteShipAuditCorrectiveActionPhoto', data);
  }

  getShipAuditFileCorrectiveActionPhotoPath() {
    return this.http.get(Helper.API_URL() + '/api/VisitsAudits/GetShipAuditCorrectiveActionPhotoDirectoryPath');
  }

  generateCorrectiveActionReport(data: any) {
    return this.http.post(Helper.API_URL() + '/api/VisitsAudits/GenerateCorrectiveActionReport', data, { responseType: 'arraybuffer' as 'json' });
  }

  getGetShipCrewIDNameByShip(shipCrewID: any) {
    const paramObject = {
      'shipCrewID': shipCrewID
    }
    return this.http.post(Helper.API_URL() + '/api/Maintenance/GetShipCrewIDNameByShip', paramObject);
  }
  // #endregion

  handleQuotaExceeded() {
    swal
      .fire({
        title: 'Error',
        html: '<span>IndexedDB storage qouta exceeded.</span>',
        icon: "error",
        confirmButtonText: "OK",
        allowOutsideClick: false,
        allowEscapeKey: false,
      })
      .then((result) => {
        if (result.value) {
        }
      });
  }
}
